<div class="modal-header">
  <h2>{{ headerText }}</h2>
</div>
<hr />
<ng-container *ngIf="bodyTemplate; else textBody">
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
  </div>
</ng-container>
<ng-template #textBody>
  <div [innerHTML]="bodyText" class="modal-body"></div>
</ng-template>
<hr />
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="onClose('Close click')"
    [disabled]="state === formStates.submitting"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-success"
    (click)="onConfirm()"
    [disabled]="state === formStates.submitting"
  >
    {{ confirmButtonText }}
  </button>
</div>

<div *ngIf="state === formStates.submitting" class="loading">
  <app-loading-spinner></app-loading-spinner>
</div>
